export default KR => {
  return {
    onTabChange: KR._addCallback('wallet.onTabChange'),
    onPaymentTokenDeleted: KR._addCallback('wallet.onPaymentTokenDeleted')
  }
}
